export default class HealthReport {

	constructor (data) {
		if (data) {
			this.id = parseInt(data.id)
			this.name = data.name
			this.report = data.report
			this.responsible = data.responsible
			this.datetime = data.date_hour
			this.attachments = data.attachments
		} else {
			this.name = ''
			this.report = ''
			this.responsible = ''
			this.datetime = ''
			this.attachments = []
		}
	}
}



// WEBPACK FOOTER //
// ./src/classes/HealthReport.js